import type { GetPlacesListItem } from "@birdwatch/client";

import { PlaceTypeIcon } from "@/components/ui/status/place-type-icon";
import { renderPlaceAddress } from "@/features/office/places/_libs/utils";
import type { PlaceType } from "@/types/openapi-enum";

import type { FilterOption } from "../types";

/**
 * Place → `FilterOption` mapper for the declarative entity filters. A
 * place-type icon + a two-line body (name + city/state/zip), matching the
 * legacy place picker. Shared by every place picker (admin
 * users/subscriptions/purchase-intents, office places/tasks) so they render
 * identically. A name-only fallback is what made the rows drift from the legacy
 * pickers (QA #4).
 */
export function toPlaceFilterOption(place: GetPlacesListItem): FilterOption {
  return {
    value: place.id,
    label: place.name || place.id,
    icon: (
      <PlaceTypeIcon
        type={place.type as PlaceType}
        className="shrink-0 size-5"
      />
    ),
    pill: (
      <div className="bg-bg-surface-elevate-low outline outline-outline-dark-min rounded-sm">
        <PlaceTypeIcon type={place.type as PlaceType} size={14} />
      </div>
    ),
    detail: (
      <div className="flex flex-col min-w-0">
        <span className="text-sm leading-5 font-normal text-text-dark-max line-clamp-1 break-all">
          {place.name || place.id}
        </span>
        <span className="text-xs leading-4 font-normal text-text-dark-low line-clamp-1 break-all">
          {renderPlaceAddress(place, ["city", "state", "zipcode"])}
        </span>
      </div>
    ),
  };
}
